module.exports = __webpack_public_path__ + "images/icons/boat-storage/10x15--boat-space.svg";